<template>
  <v-card
    class="image-container"
    height="100%"
    border
  >
    <v-card-title class="py-0">
      <v-toolbar
        flat
        color="transparent"
        class="px-0"
      >
        <v-toolbar-title class="text-body-h4">
          {{ title }}
        </v-toolbar-title>
        <v-chip
          class="ml-2 font-weight-bold"
          pill
          size="small"
        >
          {{ acceptLabel }}
        </v-chip>
        <v-spacer />

        <DialogComponent
          v-if="canDeleteImage && !disabled"
          action="delete"
          :title="$t('settings.company.images.image-container.title', { title })"
          :content="$t('settings.company.images.image-container.content')"
          :submit="() => deleteImage(name)"
        >
          <v-icon
            color="grey"
            style="right: -20px"
          >
            mdi-delete
          </v-icon>
        </DialogComponent>
      </v-toolbar>
    </v-card-title>

    <v-card-text>
      <!-- Preview Image -->
      <!-- TODO: check unsupported prop: contain -->
      <r-img
        v-if="src"
        :src="src"
        height="150px"
        class="my-2"
      />
      <div
        v-else
        style="height: 150px"
        class="my-2 bg-grey-lighten-3 rounded d-flex flex-column justify-center align-center"
      >
        <v-icon
          size="x-large"
          contain
          color="grey"
        >
          mdi-emoticon-sad-outline
        </v-icon>
        <span class="text-grey text-caption font-weight-bold">{{
          $t('settings.company.images.image-container.no-image')
        }}</span>
      </div>

      <!-- Description of requirements -->
      <div class="mb-4 text-body-2">
        {{ description }}
      </div>

      <CropImageUpload
        :min-height="minHeight"
        :min-width="minWidth"
        :min-opacity="minOpacity"
        :accept="accept"
        :ratio="ratio"
        :disabled="disabled"
        :name="name"
        :ask-for-image-rights="askForImageRights"
        :save="(image) => saveImage(image, name)"
        @showUpsellingDialog="$emit('showUpsellingDialog')"
      />
    </v-card-text>
  </v-card>
</template>

<script>
import CropImageUpload from '@/components/CropImageUpload'

import DialogComponent from './forms/Dialog.vue'

export default {
  components: { CropImageUpload, DialogComponent },
  props: {
    name: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: 'Logo',
    },
    description: {
      type: String,
      default: '',
    },
    src: {
      type: String,
      default: '',
    },
    minHeight: {
      type: Number,
      default: 1200,
    },
    minWidth: {
      type: Number,
      default: 1200,
    },
    minOpacity: {
      type: Number,
      default: 0,
    },
    ratio: {
      type: Number,
      default: 0,
    },
    accept: {
      type: String,
      default: 'image/png,image/jpeg,image/svg,image/svg+xml',
    },
    canDeleteImage: {
      type: Boolean,
      default: false,
    },
    askForImageRights: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    saveImage: {
      type: Function,
      default: () => {},
    },
    deleteImage: {
      type: Function,
      default: () => {},
    },
  },
  emits: ['showUpsellingDialog'],
  computed: {
    acceptLabel() {
      const acceptLabels = new Set()
      const acceptMap = {
        'image/png': 'PNG',
        'image/jpeg': 'JPEG',
        'image/svg': 'SVG',
        'image/svg+xml': 'SVG',
      }
      this.accept.split(',').forEach((type) => {
        if (acceptMap[type]) {
          acceptLabels.add(acceptMap[type])
        }
      })
      return [...acceptLabels].join(', ')
    },
  },
}
</script>

<style>
.image-container .v-toolbar .v-toolbar-title__placeholder {
  color: #000;
}
</style>
